import { Link as RouterLink } from 'ui/utilities';
import { mixins, styled } from 'ui/theme';

export const Link = {
  Base: styled('a')`
    ${mixins.link};
  `,

  Router: styled(RouterLink)`
    ${mixins.link};
  `,
};
